import { jsx as ___EmotionJSX } from "@emotion/core";
import React, { Children } from 'react';
import { ThemeProvider as EmotionThemeProvider } from 'emotion-theming';
import mineralTheme from "./mineralTheme";
import { themeProviderPropTypes } from "./propTypes";

var ThemeProvider = function ThemeProvider(props) {
  var children = props.children,
      theme = props.theme;
  return ___EmotionJSX(EmotionThemeProvider, {
    theme: theme
  }, Children.only(children));
};

ThemeProvider.displayName = 'ThemeProvider';
ThemeProvider.defaultProps = {
  theme: mineralTheme
};
ThemeProvider.propTypes = process.env.NODE_ENV !== "production" ? themeProviderPropTypes : {};
export default ThemeProvider;